import { render, staticRenderFns } from "./nftorder.vue?vue&type=template&id=55fa977c&"
import script from "./nftorder.vue?vue&type=script&lang=js&"
export * from "./nftorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports